import BaseApiClient from '../BaseApiClient';
import type {
  CallEntityType,
  TwilioInitiateCallOptions,
  TwilioInitiateCallResponse,
  TwilioTokenResponse
} from './twilio-types';

export type {
  CallEntityType,
  TwilioInitiateCallOptions,
  TwilioInitiateCallResponse,
  TwilioTokenResponse
} from './twilio-types';

export class ApiTwilio extends BaseApiClient {
  /**
   * Access token for this user's browser, issued under their stable client identity so the device
   * can register and stay reachable for inbound calls.
   */
  async getToken(): Promise<TwilioTokenResponse> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/phone/token')
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  /**
   * Initiate outbound call for a specific entity (individual, task, company, or user)
   * Returns call data and access token
   *
   * Individuals also accept a number to dial in place of their own and the quote the call is about.
   */
  async initiateCall(
    entityId: string,
    entityType: CallEntityType,
    options?: TwilioInitiateCallOptions
  ): Promise<TwilioInitiateCallResponse> {
    return new Promise((resolve, reject) => {
      const headers =
        entityType === 'akoni-index-users'
          ? { Version: '2022-12-23' }
          : undefined;
      const body =
        options?.telephone || options?.quoteId
          ? { telephone: options.telephone, quote_id: options.quoteId }
          : undefined;
      this.client
        .post(`/phone/${entityType}/${entityId}`, body, { headers })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}

export {
  useTwilioInitiateCallMutation,
  type TwilioInitiateCallVariables
} from './use-twilio-mutations';
